import React from "react";
import Navbar from "../components/Navbar";
import "../styles/global.css";
import Footer from "../components/Footer";
import Testimonials from "../components/Testimonials";
import { Helmet } from "react-helmet-async";

const TestimonialsPage = () => {
  return (
    <>
      <Helmet>
        <title>Testimonials | TimeWatch Infocom</title>
        <meta
          name="description"
          content="Watch real customer testimonials and success stories from TimeWatch Infocom, a trusted provider of biometric solutions, access control systems, and smart security technologies. Discover how our innovative security solutions, including time attendance systems, entrance automation, and parking management, have transformed businesses and organizations. Our satisfied clients share their experiences with our reliable, cutting-edge products and exceptional customer service. Learn why TimeWatch Infocom is the preferred choice for businesses seeking advanced security technologies and solutions."
        />
        <link
          rel="canonical"
          href="https://www.timewatchindia.com/testimonials"
        />
      </Helmet>
      <header className="navbar">
        <Navbar />
      </header>

      <div className="content-container">
        <section className="testimonial">
          <Testimonials />
        </section>
      </div>

      <footer className="footer">
        <Footer />
      </footer>
    </>
  );
};

export default TestimonialsPage;
